var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "dataform",
    attrs: {
      layout: "inline",
      model: _vm.form,
      labelAlign: "left"
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("批改时间"),
      prop: "correctTime"
    }
  }, [_c("a-range-picker", {
    staticStyle: {
      width: "100%"
    },
    model: {
      value: _vm.form.correctTime,
      callback: function ($$v) {
        _vm.$set(_vm.form, "correctTime", $$v);
      },
      expression: "form.correctTime"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("批改生效时间"),
      prop: "correctEffectiveTime"
    }
  }, [_c("a-range-picker", {
    staticStyle: {
      width: "100%"
    },
    model: {
      value: _vm.form.correctEffectiveTime,
      callback: function ($$v) {
        _vm.$set(_vm.form, "correctEffectiveTime", $$v);
      },
      expression: "form.correctEffectiveTime"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("批改申请号"),
      prop: "applyNumber"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("批改申请号"),
      allowClear: ""
    },
    model: {
      value: _vm.form.applyNumber,
      callback: function ($$v) {
        _vm.$set(_vm.form, "applyNumber", $$v);
      },
      expression: "form.applyNumber"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      width: "100%"
    }
  }, [_c("div", {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchList
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.resetFun
    }
  }, [_vm._v(_vm._s(_vm.$t("重置")))])], 1)])], 1)], 1)], 1), _c("div", {
    staticClass: "func-btns"
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      ghost: ""
    },
    on: {
      click: function ($event) {
        _vm.batchDownVisible = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("批量下载批改记录")))])], 1), _vm.correctionRecordList.length === 0 ? _c("div", {
    staticClass: "empty-list"
  }, [_c("svg-icon", {
    staticStyle: {
      "margin-top": "10px",
      "flex-basis": "100%"
    },
    attrs: {
      icon: "emptyData",
      size: 100
    }
  }), _c("p", [_vm._v(_vm._s(_vm.$t("暂无数据")))])], 1) : _c("div", {
    staticClass: "record-list"
  }, _vm._l(_vm.correctionRecordList, function (correctionItem) {
    return _c("div", {
      key: correctionItem.id,
      staticClass: "list-item"
    }, [_c("a-row", [_c("a-col", {
      attrs: {
        span: "8"
      }
    }, [_c("span", {
      staticClass: "key-label"
    }, [_vm._v(_vm._s(_vm.$t("批改时间") + "："))]), _c("span", {
      staticClass: "key-value"
    }, [_vm._v(_vm._s(correctionItem.correctAt))])]), _c("a-col", {
      attrs: {
        span: "8"
      }
    }, [_c("span", {
      staticClass: "key-label"
    }, [_vm._v(_vm._s(_vm.$t("批改生效时间") + "："))]), _c("span", {
      staticClass: "key-value"
    }, [_vm._v(_vm._s(correctionItem.correctEffectiveAt))])]), _c("a-col", {
      attrs: {
        span: "8"
      }
    }, [_c("span", {
      staticClass: "key-label"
    }, [_vm._v(_vm._s(_vm.$t("批改申请号") + "："))]), _c("a-tooltip", {
      attrs: {
        title: correctionItem.applyNumber
      }
    }, [_c("span", {
      staticClass: "key-value textover"
    }, [_vm._v(_vm._s(correctionItem.applyNumber))])])], 1), _c("a-col", {
      attrs: {
        span: "8"
      }
    }, [_c("span", {
      staticClass: "key-label"
    }, [_vm._v(_vm._s(_vm.$t("保费变化量") + "："))]), _c("span", {
      staticClass: "key-value"
    }, [_vm._v(_vm._s(correctionItem.premium))])]), _c("a-col", {
      attrs: {
        span: "8"
      }
    }, [_c("span", {
      staticClass: "key-label"
    }, [_vm._v(_vm._s(_vm.$t("批改状态") + "："))]), _c("span", {
      staticClass: "key-value"
    }, [_vm._v(_vm._s(correctionItem.correctType === "SUCCESS" ? _vm.$t("批改成功") : ""))])])], 1), _c("div", {
      staticClass: "detail"
    }, [_c("span", {
      staticClass: "key-label"
    }, [_vm._v(_vm._s(_vm.$t("批改详情") + "："))]), correctionItem.detailObj.count <= 10 ? _c("span", {
      staticClass: "key-value"
    }, [_vm._v(_vm._s(_vm.$t("兹经投保人申请") + "，" + _vm.$t("自1零时起进行如下变更").replace("1", correctionItem.correctEffectiveAt.replace(" 00:00:00", ""))) + "： "), correctionItem.detailObj.replaceCount ? _c("span", [_vm._v(" " + _vm._s(_vm.$t("替换人员清单") + ":") + " "), _vm._l(correctionItem.detailObj.replaceItems, function (item, index) {
      return _c("span", {
        key: index
      }, [_vm._v(" " + _vm._s(_vm.$t("姓名由") + item.REDUCE.name + _vm.$t("变更为") + item.INCREASE.name) + ", " + _vm._s(_vm.$t("证件号码由-变更为_").replace("-", item.REDUCE.idNumber).replace("_", item.INCREASE.idNumber)) + " "), _c("span", [_vm._v(_vm._s(index === Number(correctionItem.detailObj.replaceCount) - 1 ? "。" : ",") + " ")])]);
    })], 2) : _vm._e(), correctionItem.detailObj.addCount ? _c("span", [_vm._v(" " + _vm._s(_vm.$t("新增人员清单") + ":") + " "), _vm._l(correctionItem.detailObj.incrementItems, function (item, index) {
      return _c("span", {
        key: index
      }, [_vm._v(" " + _vm._s(_vm.$t("姓名") + item.name) + "," + _vm._s(_vm.$t("证件号码") + item.idNumber) + " "), _c("span", [_vm._v(_vm._s(index === Number(correctionItem.detailObj.addCount) - 1 ? "。" : ","))])]);
    })], 2) : _vm._e(), correctionItem.detailObj.delCount ? _c("span", [_vm._v(" " + _vm._s(_vm.$t("减少人员清单") + ":") + " "), _vm._l(correctionItem.detailObj.reduceItems, function (item, index) {
      return _c("span", {
        key: index
      }, [_vm._v(" " + _vm._s(_vm.$t("姓名") + item.name) + "," + _vm._s(_vm.$t("证件号码") + item.idNumber) + " "), _c("span", [_vm._v(_vm._s(index === Number(correctionItem.detailObj.delCount) - 1 ? "。" : ","))])]);
    })], 2) : _vm._e()]) : _c("span", {
      staticClass: "key-value"
    }, [_vm._v(" " + _vm._s(_vm.$t("兹经投保人申请") + "，" + _vm.$t("自1零时起进行如下变更").replace("1", correctionItem.correctEffectiveAt.replace(" 00:00:00", ""))) + "： "), correctionItem.detailObj.replaceCount ? _c("span", [_vm._v(_vm._s(_vm.$t("更改投保人员0名").replace("0", correctionItem.detailObj.replaceCount)) + "，")]) : _vm._e(), correctionItem.detailObj.addCount ? _c("span", [_vm._v(_vm._s(_vm.$t("新增投保人员0名").replace("0", correctionItem.detailObj.addCount)) + "，")]) : _vm._e(), correctionItem.detailObj.delCount ? _c("span", [_vm._v(" " + _vm._s(_vm.$t("不再承担人员保险责任的投保人0名").replace("0", correctionItem.detailObj.delCount)) + "，")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t("变更明细详见批改详情")) + " ")]), _c("span", {
      staticClass: "key-value"
    }, [_vm._v(_vm._s(_vm.$t("综上所述：")) + _vm._s(_vm.$t("由此需要")) + _vm._s(correctionItem.detailObj.premiumType === "INCREASE" ? _vm.$t("加收") : _vm.$t("退还")) + "：" + _vm._s(correctionItem.detailObj.premium) + "元 ")]), _vm._v("    "), _c("span", {
      staticClass: "see-more",
      on: {
        click: function ($event) {
          $event.preventDefault();
          return _vm.toDetail(correctionItem);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("点击查看")) + ">>")])]), _c("div", {
      staticClass: "btns"
    }, [_c("a-button", {
      attrs: {
        type: "primary",
        ghost: ""
      },
      on: {
        click: function ($event) {
          $event.stopPropagation();
          return _vm.downSingleRecord(correctionItem);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("批改人员下载")))])], 1)], 1);
  }), 0), _c("div", {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "right"
    }
  }, [_vm.correctionRecordList.length !== 0 ? _c("a-pagination", {
    attrs: {
      pageSize: _vm.pagination.pageSize,
      total: _vm.pagination.total,
      "show-size-changer": "",
      "show-quick-jumper": "",
      "show-less-items": "",
      "show-total": total => _vm.$t("共") + total + _vm.$t("条")
    },
    on: {
      change: _vm.onPageChange,
      showSizeChange: _vm.onShowSizeChange
    },
    model: {
      value: _vm.pagination.current,
      callback: function ($$v) {
        _vm.$set(_vm.pagination, "current", $$v);
      },
      expression: "pagination.current"
    }
  }) : _vm._e()], 1), _c("correction-detail", {
    attrs: {
      detailVisible: _vm.detailVisible,
      correctionItem: _vm.correctionItem
    },
    on: {
      "update:detailVisible": function ($event) {
        _vm.detailVisible = $event;
      },
      "update:detail-visible": function ($event) {
        _vm.detailVisible = $event;
      },
      closeDetail: _vm.closeDetail
    }
  }), _c("batch-down-record", {
    attrs: {
      batchDownVisible: _vm.batchDownVisible
    },
    on: {
      "update:batchDownVisible": function ($event) {
        _vm.batchDownVisible = $event;
      },
      "update:batch-down-visible": function ($event) {
        _vm.batchDownVisible = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };